(function ($) {
    if ($('section.developments').length) {
        var swiperDevelopments = new Swiper('.swiper.developments', {
            pagination: {
                el: '.swiper-pagination-fraction',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next-dev',
                prevEl: '.swiper-button-prev-dev',
            },
            slidesPerView: 2,
            spaceBetween: 10,
            // loop: true,
            slidesPerGroup: 1,
            loopFillGroupWithBlank: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 30
                },
                800: {
                    slidesPerView: 1.65,
                    spaceBetween: 20
                },
                // 1200: {
                //     slidesPerView: 2,
                //     spaceBetween: 20
                // }
            },
            // on: {
            //     slideChangeTransitionStart: function () {
            //         $('.img-wrap img').hide(0);
            //         $('.img-wrap img').removeClass('aos-init').removeClass('aos-animate');
            //     },
            //     slideChangeTransitionEnd: function () {
            //         $('.img-wrap img').show(0);
            //         AOS.init();
            //     },
            // }
        });
    }
    $('.faq-block .question').click(function(){
        let answerHeight = $(this).parents('.faq-block-modal').height();
        let fullHeight = $(this).parents('.swiper-slide').height() + answerHeight;
        $(this).parents('.swiper-slide').css('height', answerHeight);

    })

})(jQuery);